import { 
  getSelectionStyle, 
  buildContainerStyle, 
  buildLabelStyle 
} from '../utils/styleHelpers';
import { 
  buildSelectClasses, 
  buildControlClasses 
} from '../utils/classBuilders';

export const useSelectStyles = ({ 
  isSelected, isHovered, enabled, 
  width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
  backgroundColor, borderRadius, padding, position, lockedEdges,
  top, left, right, bottom, unit, style,
  labelFontSize, fontFamily, labelBold, labelItalic,
  bulmaSize, bulmaColor, bulmaStyle, bulmaState, isMultiple,
  hasIcon, iconPosition, selectClass
}) => {
  const selectionStyle = getSelectionStyle(isSelected, isHovered, enabled);
  
  const containerStyle = buildContainerStyle({
    width, maxWidth, minWidth, flex, flexGrow, flexShrink, flexBasis,
    backgroundColor, borderRadius, padding, position, lockedEdges,
    top, left, right, bottom, unit, style
  });

  const labelStyle = buildLabelStyle({ 
    labelFontSize, fontFamily, labelBold, labelItalic 
  });

  const selectClasses = buildSelectClasses({ 
    bulmaSize, bulmaColor, bulmaStyle, bulmaState, isMultiple 
  });

  const controlClasses = buildControlClasses({ 
    hasIcon, iconPosition, selectClass 
  });

  return {
    containerStyle: { ...containerStyle, ...selectionStyle },
    labelStyle,
    selectClasses,
    controlClasses
  };
};